import React from "react";
import { useLayout } from "../layout/LayoutContext";
import PortalRoot from "../portal/PortalRoot";
import { OverlayOpacity } from "../portal/types";
import Inbox, { InboxProps } from "./Inbox";
import { useUser } from "../../contexts/UserContext";

const InboxPortalView: React.FC<InboxProps> = (props) => {
    const { baseZIndex } = useLayout();
    const { user } = useUser();

    if (user === null) {
        return <></>;
    }

    return (
        <PortalRoot
            baseZIndex={baseZIndex}
            overlayOpacity={OverlayOpacity.COVERED}
        >
            <Inbox {...props} baseZIndex={baseZIndex} user={user} />
        </PortalRoot>
    );
};

export default InboxPortalView;
